import { useCallback, useMemo, useState } from 'react';
import * as columnDefs from '../../../../components/AGGrid/config/columns-def';
import {filterCriteria} from "../../../../utils/filterCriteria";


export function useCommentsGridUtils({
                                         datastageApi,
                                         filterForm,
                                         commentRange,
                                            commentProduct,
                                         updateComments,
                                         handlers
                                     }) {
    const [sortedColId, setSortedColId] = useState(null);
    const [sortDirection, setSortDirection] = useState('asc');

    const setSort = useCallback(
        async (colId, direction) => {
            setSortedColId(colId);
            setSortDirection(direction);
            handlers.setLoadingTrue();
            try {
                const commentList = await datastageApi.comments(
                    filterCriteria(filterForm, commentProduct, 'comments'),
                    commentRange,
                    [colId, direction.toUpperCase()]
                );

                updateComments({
                    isCommentModalOpen: true,
                    comments: commentList?.content || [],
                    totalPages: commentList?.totalPages || 1,
                    totalItems: commentList?.totalElements || 0,
                    currentPage: commentList?.pageable?.pageNumber,
                    commentSort: [colId, direction.toUpperCase()]
                });
            } catch (error) {
                console.error('Error sorting comments:', error);
            } finally {
                handlers.setLoadingFalse();
            }
        },
        [filterForm, commentRange, updateComments, handlers]
    );

    const baseColumns = columnDefs['comments'](
        ...handlers.columnHandlers
    )['default'];

    const columns = useMemo(() => (
        baseColumns.map(col => ({
            ...col,
            headerComponentParams: {
                ...col.headerComponentParams,
                setSort,
                sortedColId,
                sortDirection,
            }
        }))
    ), [setSort, sortedColId, sortDirection, baseColumns]);

    return { setSort, columns };
}